<template>

        <div class="question-tab" v-if="showDropdownQuestion">
            <div class="check">
                <input @click.stop @change="checkboxChanged" type="checkbox" />
            </div>
            <p>{{ heading }}</p>
            <div class="checkbox-div" v-if="showYesNo">
                <div class="check">
                    <input type="checkbox" />
                    <p>Yes</p>
                </div>
                <div class="check">
                    <input type="checkbox" />
                    <p>No</p>
                </div>
            </div>
        </div>
        <div v-else class="yesnoQuestion">
            <p>{{ heading }}</p>
            <div class="checkbox-div">
                <div class="check">
                    <input type="checkbox" />
                    <p>Yes</p>
                </div>
                <div class="check">
                    <input type="checkbox" />
                    <p>No</p>
                </div>
            </div>
        </div>
 
</template>
<script>
import multipleAnswers from "./multiple-answer.vue";

export default {
    name: "questionTab",
    components: {},
    props: {
        heading: String,
        showYesNo: Boolean,
        showDropdownQuestion: Boolean,
    },
    data() {
        return {};
    },
    methods: {
    checkboxChanged(event) {
      this.$emit('checkbox-updated', event.target.checked);
    }
  }

};
</script>
<style lang="scss" scoped>
.question-tab {
    height: 51px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    gap: 16px;
    margin-left: 2px;
    width: 100%;
    p {
        margin: 0;
    }
}
.yesnoQuestion {
    height: 51px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-left: 28px;
    width: 100%;
    p {
        margin: 0;
    }
}
.checkbox-div {
    display: flex;
    align-items: center;
    width: 40%;
    gap: 32px;

    .check {
        display: flex;
        align-items: center;
        gap: 12px;
        p {
            color: #4b4b4b;
        }
    }
}
input[type="checkbox"] {
    accent-color: #189d3b;
    height: 16px;
    width: 16px;
    border-radius: 4px;
}
</style>
